<div class="content p-3">
  <a href="https://upscapital.com/" target="_blank" rel="noopener noreferrer">
    <img alt="UPS Capital Logo" *ngIf="!isCanadaUser" src="../../../assets/logos/ca_us/InsureShield_Logo_226x79_larger_tagline-01.png">
    <img alt="UPS Capital Logo" *ngIf="isCanadaUser" src="../../../assets/logos/ca_us/UPSC_InsureShield_Horizontal CANADA_226x79_72dpi.png">
  </a>
  <div class="loading" *ngIf="loading">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div class="description">Routing you...</div>
  </div>
  <div class="error" *ngIf="systemError">
    {{ 'common.systemError' | translate }}
  </div>
</div>